module.exports = __webpack_public_path__ + "static/media/empty-trip-list-vector.1d1cd575.svg";